import Vue from "vue";
import { createRouter, createWebHistory } from 'vue-router'
import store from "../store";

// Public
import MainPage from            '@/views/public/Index.vue'
import Denied from              '@/views/public/Denied.vue'
import Auth from                '@/views/public/auth/Auth.vue'
import Registration from        '@/views/public/auth/Registration.vue'
import RegStepFillData from     '@/views/public/auth/RegStepFillData.vue'
import RegStepPopup from        '@/views/public/auth/RegStepPopup.vue'
import ForgotPass from          '@/views/public/auth/ForgotPass.vue'
import ForgotPassReset from     '@/views/public/auth/ForgotPassReset.vue'
import Logout from              '@/views/public/auth/Logout.vue'
import FAQ from                 '@/views/public/FAQ.vue'
import Support from             '@/views/public/Support.vue'
import Reviews from             '@/views/public/Reviews.vue'
import NotFound from            '@/views/public/NotFound.vue'
import About from               '@/views/public/About.vue'
import Subscribed from          '@/views/public/Subscribed.vue'
import Bill from                '@/views/public/Bill.vue'
import Deal from                '@/views/public/Deal.vue'
import Ref from                 '@/views/public/Ref.vue'                    // page_mode
import SubscribeForm from       '@/views/public/SubscribeForm.vue'          // page_mode
import Policy from              '@/views/public/Policy.vue'
import Terms from               '@/views/public/Terms.vue'
import AML from                 '@/views/public/Aml.vue'
import Status from              '@/views/public/Status.vue'
import Converter from           '@/views/public/Converter.vue'

// LP
import RubIdr from              '@/views/public/lp/RubIdr.vue'
import RubThb from              '@/views/public/lp/RubThb.vue'
import RubInr from              '@/views/public/lp/RubInr.vue'
import RubVnd from              '@/views/public/lp/rub_vnd.vue'
import RubEgp from              '@/views/public/lp/rub_egp.vue'

// Personal
import Profile from             '@/views/personal/profile/index.vue'
import Recipients from          '@/views/personal/profile/recipients.vue'
import Senders from             '@/views/personal/profile/senders.vue'
import SenderAdd from          '@/views/personal/profile/sender_add.vue'
import SenderEdit from          '@/views/personal/profile/sender_edit.vue'
import Verification from        '@/views/personal/verification/index.vue'
import VerifProcess from        '@/views/personal/verification/process.vue'         // page_mode
import TransferCreate from      '@/views/personal/transfer/Create.vue'
import Transfers from           '@/views/personal/transfer/List.vue'
import TransferDetail from      '@/views/personal/transfer/Detail.vue'
import Partner from             '@/views/personal/partner/Index.vue'
import PersonalWallets from     '@/views/personal/wallet/Index.vue'
import PersonalWallet from      '@/views/personal/wallet/Detail.vue'
import WalletsTransactions from '@/views/personal/wallet/AllTransactions.vue'
import PersonalTransactions from'@/views/personal/wallet/Transactions.vue'
import PersonalAccount from     '@/views/personal/Account.vue'
import CreateBill from          '@/views/personal/bill/Create.vue'
import Bills from               '@/views/personal/bill/Index.vue'
import PersonalBill from        '@/views/personal/bill/Detail.vue'
import Products from            '@/views/personal/products/index.vue'
import Esim from                '@/views/personal/products/esim.vue'
import Instruction from         '@/views/personal/Instruction.vue'
import Cards from               '@/views/personal/vcard/Index.vue'
import VCard from               '@/views/personal/vcard/Detail.vue'
import PersonalVcardTrans from  '@/views/personal/vcard/transactions.vue'

// Merchant
import MerchantIndex from       '@/views/merchant/Index.vue'
import MerchantTransfers from   '@/views/merchant/transfer/List.vue'
import MerchantTransferDetail from '@/views/merchant/transfer/Detail.vue'
import MerchantStat from        '@/views/merchant/MerchantStat'
import RepeatScan from          '@/views/merchant/RepeatScan.vue'
import MerchantRates from       '@/views/merchant/Rates.vue'

// Admin
import AdminIndex from          '@/views/admin/Index.vue'
import AdminStat from           '@/views/admin/Stat.vue'
import AdminBalances from       '@/views/admin/balances.vue'
import AdminUsers from          '@/views/admin/user/List.vue'
import AdminMerchants from      '@/views/admin/merchant/list.vue'
import AdmMerchantDetail from   '@/views/admin/merchant/detail.vue'
import AdminUserDetail from     '@/views/admin/user/Detail.vue'
import AdminUserWalletDetail from '@/views/admin/user/wallet_detail.vue'
import AdmTransfers from        '@/views/admin/transfer/List.vue'
import AdmTransferDetail from   '@/views/admin/transfer/Detail.vue'
import AdmPartnerList from      '@/views/admin/Partners'
import AdminPartnerDetail from  '@/views/admin/PartnerDetail'
import AdmWalletDetail from     '@/views/admin/wallet/Detail.vue'
import AdmWallets from          '@/views/admin/wallet/List.vue'
import AdmTrns from             '@/views/admin/transactions/List.vue'
import AdmAccDetail from        '@/views/admin/account/Detail.vue'
import AdmAccounts from         '@/views/admin/account/List.vue'
import AdmRates from            '@/views/admin/Rates'
import AdmBanks from            '@/views/admin/Banks'
import AdminPays from           '@/views/admin/Pays'
import AdminFiles from          '@/views/admin/Files'
import AdminOperations from     '@/views/admin/operations/list.vue'
import AdmVcards from           '@/views/admin/vcard/Index.vue'
import AdmVcardDetail from      '@/views/admin/vcard/Detail.vue'
import AdminVcardTransactions from '@/views/admin/vcard/transactions.vue'
import AdminSenders from        '@/views/admin/senders/index.vue'
import AdminRecipients from     '@/views/admin/recipients/index.vue'
import AdminRecipientsBlacklist from '@/views/admin/recipients/blacklist.vue'

function isUserInGroup (group, objGroups) { 
    if(!group) return false
    if(!objGroups) return false
    let groups = [], in_group = false
    if(objGroups && typeof(objGroups) == 'object') groups = Array.from(objGroups) 
    else return false
    if(groups.includes(group)) in_group = true
    return (in_group) ? true : false
}

const routes = [
    {
        path: '/',
        name: 'Main Page',
        name_ru: 'Главная',
        component: MainPage,
        meta: {
            requiresAuth: false,
            title: 'Main Page | PayWave',
            title_ru: 'Главная | PayWave',
        }
    },
    {
        path: '/rub-idr/',
        name: 'Transfer RUB to IDR',
        name_ru: 'Денежные переводы из России в Индонезию',
        component: RubIdr,
        meta: {
            requiresAuth: false,
            title: 'Transfer RUB to IDR | PayWave',
            title_ru: 'Сервис для международных переводов денег PayWave | PayWave',
        }
    },
    {
        path: '/rub-thb/',
        name: 'Transfer RUB to THB',
        name_ru: 'Денежные переводы из России в Тайланд',
        component: RubThb,
        meta: {
            requiresAuth: false,
            title: 'Transfer RUB to THB | PayWave',
            title_ru: 'Сервис для переводов денег из России в Тайланд и обратно | PayWave',
        }
    },
    {
        path: '/rub-vnd/',
        name: 'Transfer RUB to VND',
        name_ru: 'Денежные переводы из России во Вьетнам',
        component: RubVnd,
        meta: {
            requiresAuth: false,
            title: 'Transfer RUB to VND | PayWave',
            title_ru: 'Сервис для переводов денег из России во Вьетнам и обратно | PayWave',
        }
    },
    {
        path: '/rub-egp/',
        name: 'Transfer RUB to EGP',
        name_ru: 'Денежные переводы из России в Египет',
        component: RubEgp,
        meta: {
            requiresAuth: false,
            title: 'Transfer RUB to EGP | PayWave',
            title_ru: 'Сервис для переводов денег из России в Египет и обратно | PayWave',
        }
    },
    {
        path: '/rub-inr/',
        name: 'Transfer RUB to INR',
        name_ru: 'Денежные переводы из России в Индию',
        component: RubInr,
        meta: {
            requiresAuth: false,
            title: 'Transfer RUB to INR | PayWave',
            title_ru: 'Денежные переводы из России в Индию | PayWave',
        }
    },
    {
        path: '/auth/',
        name: 'Authorization',
        component: Auth,
        name_ru: 'Авторизация',
        meta: {
            requiresAuth: false,
            title: 'Authorization | PayWave',
            title_ru: 'Авторизация | PayWave',
        },
        menu_type: ['right'],
        sort: 101
    },
    {
        path: '/reg/',
        name: 'Registration',
        name_ru: 'Регистрация',
        component: Registration,
        meta: {
            requiresAuth: false,
            title: 'Registration | PayWave',
            title_ru: 'Регистрация | PayWave',
        },
        menu_type: ['right'],
        sort: 102
    },
    {
        path: '/reg/fill/',
        name: 'Fill your data', 
        name_ru: 'Заполните данные',
        component: RegStepFillData,
        meta: {
            requiresAuth: true,
            title: 'Fill your data | PayWave',
            title_ru: 'Заполните данные | PayWave',
        },
        sort: 102
    },
    {
        path: '/reg/email/',
        name: 'Confirm your email', 
        name_ru: 'Подтверждение регистрации',
        component: RegStepPopup,
        meta: {
            requiresAuth: true,
            title: 'Confirm your email | PayWave',
            title_ru: 'Подтверждение регистрации | PayWave',
        },
        sort: 102
    },
    {
        path: '/pass/',
        name: 'Forgot Password',
        name_ru: 'Забыл пароль',
        component: ForgotPass,
        meta: {
            requiresAuth: false,
            title: 'Forgot password | PayWave',
            title_ru: 'Забыл пароль | PayWave',
        },
        menu_type: ['right'],
        sort: 103
    },
    {
        path: '/logout/',
        name: 'Logout',
        name_ru: 'Выход',
        component: Logout,
        meta: {
            requiresAuth: true,
            title: 'Logout | PayWave',
            title_ru: 'Выход | PayWave',
        },
        menu_type: ['rightAuth'],
    },
    {
        path: '/instruction/',
        name: 'Instruction',
        name_ru: 'Инструкция',
        component: Instruction,
        meta: {
            requiresAuth: true,
            title: 'Instruction | PayWave',
            title_ru: 'Инструкция | PayWave',
        },
        menu_type: ['mobAuth'],
        menu_level: 1,
        sort: 301
    },
    {
        path: '/instruction/',
        name: 'Instruction',
        name_ru: 'Инструкция',
        component: Instruction,
        meta: {
            requiresAuth: true,
            title: 'Instruction | PayWave',
            title_ru: 'Инструкция | PayWave',
        },
        menu_type: ['leftAuth', 'bottom'],
        menu_level: 2,
        menu_parent: 'Info',
        sort: 301
    },
    // {
    //     path: '/terms/',
    //     name: 'Terms',
    //     name_ru: 'Условия использования',
    //     component: Terms,
    //     meta: {
    //         requiresAuth: false,
    //         title: 'Terms | PayWave',
    //         title_ru: 'Условия использования | PayWave',
    //     },
    //     menu_type: ['bottom'],
    //     sort: 310
    // },
    {
        path: '/merchant/',
        name: 'Merchant',
        name_ru: 'Мерчантам',
        component: MerchantIndex,
        meta: {
            requiresAuth: true,
        },
        menu_type: ['bottom'],
        sort: 311
    },
    {
        path: '/about/',
        name: 'About',
        name_ru: 'О компании',
        component: About,
        meta: {
            requiresAuth: false,
            title: 'About PayWave',
            title_ru: 'О компании PayWave',
        },
        menu_type: ['left', 'bottom', 'mob'],
        sort: 303
    },
    {
        path: '/about/',
        name: 'About',
        name_ru: 'О компании',
        component: About,
        meta: {
            requiresAuth: false,
            title: 'About PayWave',
            title_ru: 'О компании PayWave',
        },
        menu_type: ['leftAuth', 'bottom', 'mob'],
        menu_level: 2,
        menu_parent: 'Info',
        sort: 304
    },
    {
        path: '/support/faq/',
        name: 'Info',
        name_ru: "Инфо",
        component: FAQ,
        meta: {
            requiresAuth: false,
            title: 'FAQ | PayWave',
            title_ru: 'FAQ | PayWave',
        },
        menu_type: ['left', 'leftAuth', 'mob', 'mobAuth'],
        sort: 305
    },
    {
        path: '/support/faq/',
        name: 'FAQ',
        name_ru: "FAQ",
        component: FAQ,
        meta: {
            requiresAuth: false,
            title: 'FAQ | PayWave',
            title_ru: 'FAQ | PayWave',
        },
        menu_type: ['leftAuth', 'bottom'],
        menu_level: 2,
        menu_parent: 'Info',
        sort: 303
    },
    {
        path: '/support/faq/',
        name: 'FAQ',
        name_ru: "FAQ",
        component: FAQ,
        meta: {
            requiresAuth: false,
            title: 'FAQ | PayWave',
            title_ru: 'FAQ | PayWave',
        },
        menu_type: ['bottom'],
        sort: 303
    },
    {
        path: '/support/',
        name: 'Support',
        name_ru: 'Поддержка',
        component: Support,
        meta: {
            requiresAuth: false,
            title: 'Support | PayWave',
            title_ru: 'Поддержка | PayWave',
        },
        menu_type: ['mob', 'mobAuth', 'bottom'],
        menu_level: 1,
        sort: 304
    },
    {
        path: '/support/',
        name: 'Support',
        name_ru: 'Поддержка',
        component: Support,
        meta: {
            requiresAuth: false,
            title: 'Support | PayWave',
            title_ru: 'Поддержка | PayWave',
        },
        menu_type: ['leftAuth', 'bottom', 'mob'],
        menu_level: 2,
        menu_parent: 'Info',
        sort: 304
    },
    {
        path: '/reviews/',
        name: 'Reviews',
        name_ru: 'Отзывы',
        component: Reviews,
        meta: {
            requiresAuth: false,
            title: 'Reviews | PayWave',
            title_ru: 'Отзывы | PayWave',
        },
        menu_type: ['left', 'bottom', 'mob'],
        sort: 305
    },
    {
        path: '/reviews/',
        name: 'Reviews',
        name_ru: 'Отзывы',
        component: Reviews,
        meta: {
            requiresAuth: false,
            title: 'Reviews | PayWave',
            title_ru: 'Отзывы | PayWave',
        },
        menu_type: ['leftAuth', 'bottom', 'mob'],
        menu_level: 2,
        menu_parent: 'Info',
        sort: 304
    },
    {
        path: '/forgot-pass/:hash',
        name: 'Restore password',
        component: ForgotPassReset,
        meta: {
            requiresAuth: false,
            title: 'Restore password | PayWave',
            title_ru: 'Восстановление пароля | PayWave',
        }
    },
    {
        path: '/subscribe/:code',
        name: 'Subscribe',
        name_ru: 'Подписка',
        component: SubscribeForm,
        meta: {
            requiresAuth: false,
            pageMode: true
        }
    },
    {
        path: '/bill/:hash',
        name: 'Get Bill',
        name_ru: 'Счет',
        component: Bill,
        meta: {
            requiresAuth: false,
            title: 'Bill | PayWave',
            title_ru: 'Счет | PayWave',
        },
    },
    {
        path: '/deal/:hash',
        name: 'Get Deal',
        name_ru: 'Сделка',
        component: Deal,
        meta: {
            requiresAuth: false,
            title: 'Deal | PayWave',
            title_ru: 'Сделка | PayWave',
        },
    },
    {
        path: '/verify/',
        name: 'Verification',
        component: Verification,
        meta: {
            requiresAuth: true,
            title: 'Verification | PayWave',
            title_ru: 'Верификация | PayWave',
        }
    },
    {
        path: '/verify/process/',
        name: 'Verification Process',
        component: VerifProcess,
        meta: {
            requiresAuth: true,
            pageMode: true,
            title: 'Verification Process | PayWave',
            title_ru: 'Верификация | PayWave',
        }
    },
    // {
    //     path: '/pay_by_url/',
    //     name: 'PayUrl',
    //     component: PayUrl,
    //     meta: {
    //         requiresAuth: false,
    //         pageMode: true
    //     }
    // },
    {
        path: '/telegram/repeatscan/:id',
        name: 'RepeatScan',
        component: RepeatScan,
        meta: {
            pageMode: true,
            requiresAuth: true,
            requiresMerchant: true,
        }
    },
    // {
    //     path: '/paypal/success/',
    //     name: 'PaypalSuccess',
    //     component: PaypalSuccess,
    //     meta: {
    //         requiresAuth: false,
    //         title: 'Paypal success | PayWave',
    //         title_ru: 'Paypal успешный перевод | PayWave',
    //     }
    // },
    // {
    //     path: '/success/',
    //     name: 'PaySuccess',
    //     component: PaySuccess,
    //     meta: {
    //         requiresAuth: false,
    //         title: 'Success | PayWave',
    //         title_ru: 'Успешный перевод | PayWave',
    //     }
    // },
    {
        path: '/subscribed/',
        name: 'Subscribed',
        component: Subscribed,
        meta: {
            requiresAuth: false,
            title: 'Subscribed success | PayWave',
            title_ru: 'Успешная подписка | PayWave',
        }
    },
    {
        path: '/ref/:code',
        name: 'Ref',
        component: Ref,
        meta: {
            requiresAuth: false,
            title: 'PayWave',
            title_ru: 'PayWave',
        }
    },
    {
        path: '/denied/',
        name: 'Access denied',
        component: Denied,
        meta: {
            requiresAuth: false,
            title: 'Access denied | PayWave',
            title_ru: 'Доступ запрещен | PayWave',
        }
    },
    {
        path: '/policy/',
        name: 'Policy',
        component: Policy,
        meta: {
            requiresAuth: false,
            title: 'Policy | PayWave',
            title_ru: 'Политика | PayWave',
        }
    },
    {
        path: '/terms/',
        name: 'Terms',
        component: Terms,
        meta: {
            requiresAuth: false,
            title: 'Terms | PayWave',
            title_ru: 'Пользовательское соглашение | PayWave',
        }
    },
    {
        path: '/aml/',
        name: 'AML',
        component: AML,
        meta: {
            requiresAuth: false,
            title: 'AML | PayWave',
            title_ru: 'AML | PayWave',
        }
    },
    {
        path: '/status/',
        name: 'Status',
        component: Status,
        meta: {
            requiresAuth: false,
            title: 'Status | PayWave',
            title_ru: 'Статус | PayWave',
        }
    },
    {
        path: '/converter/',
        name: 'Converter',
        component: Converter,
        meta: {
            requiresAuth: false,
            title: 'Converter | PayWave',
            title_ru: 'Конвертер | PayWave',
        }
    },

    // PERSONAL
    {
        path: '/personal/profile/',
        name: 'Profile',
        name_ru: 'Профиль',
        component: Profile,
        meta: {
            requiresAuth: true,
            title: 'Profile | PayWave',
            title_ru: 'Профиль | PayWave',
        },
        menu_type: ['rightAuth'],
        sort: 204
    },
    {
        path: '/personal/transfer/create/',
        name: 'Create',
        name_ru: "Создать",
        component: TransferCreate,
        meta: {
            requiresAuth: false,
            title: 'Create | PayWave',
            title_ru: 'Создать | PayWave',
        },
        menu_type: ['left', 'leftAuth'],
        sort: 1
    },
    // {
    //     path: '/personal/transfer/create/',
    //     name: 'Transfer',
    //     name_ru: 'Перевод',
    //     component: TransferCreate,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'Create a transfer | PayWave',
    //         title_ru: 'Создать перевод | PayWave',
    //     },
    //     menu_type: ['leftAuth', 'mobAuth'],
    //     menu_level: ,
    //     menu_parent: 'Create',
    //     sort: 201
    // },
    // {
    //     path: '/personal/bill/create/',
    //     name: 'Bill',
    //     name_ru: 'Счет',
    //     component: CreateBill,
    //     meta: {
    //         requiresAuth: true,
    //         isBillGroup: true,
    //         title: 'Create a bill | PayWave',
    //         title_ru: 'Создать счет | PayWave',
    //     },
    //     menu_type: ['leftAuth', 'mobAuth'],
    //     menu_level: 2,
    //     menu_parent: 'Create',
    //     sort: 201
    // },
    // {
    //     path: '/personal/deal/create/',
    //     name: 'Deal',
    //     name_ru: 'Сделку',
    //     component: CreateDeal,
    //     meta: {
    //         requiresAuth: true,
    //         isDealGroup: true,
    //         title: 'Create a deal | PayWave',
    //         title_ru: 'Создать сделку | PayWave',
    //     },
    //     menu_type: ['leftAuth', 'mobAuth'],
    //     menu_level: 2,
    //     menu_parent: 'Create',
    //     sort: 201
    // },
    {
        path: '/personal/transfers/',
        name: 'Lists of',
        name_ru: 'История',
        component: Transfers,
        meta: {
            requiresAuth: true,
            title: 'My Lists of | PayWave',
            title_ru: 'Мои переводы | PayWave',
        },
        menu_type: ['leftAuth'],
        sort: 2
    },
    // {
    //     path: '/personal/transfers/',
    //     name: 'Transfers',
    //     name_ru: 'Мои переводы',
    //     component: Transfers,
    //     meta: {
    //         requiresAuth: true,
    //         title: 'My transfers | PayWave',
    //         title_ru: 'Мои переводы | PayWave',
    //     },
    //     menu_type: ['leftAuth', 'mobAuth'],
    //     menu_level: 2,
    //     menu_parent: 'Lists of',
    //     sort: 202
    // },
    {
        path: '/personal/transfer/:id',
        name: 'Transfer Details',
        component: TransferDetail,
        meta: {
            requiresAuth: true,
            title: 'Transfer Details | PayWave',
            title_ru: 'Детали перевода | PayWave',
        },
    },
    {
        path: '/personal/products/',
        name: 'Products',
        name_ru: 'Продукты',
        component: Products,
        meta: {
            requiresAuth: true,
            title: 'Products | PayWave',
            title_ru: 'Продукты | PayWave',
        },
        menu_type: ['leftAuth', 'mobAuth'],
        sort: 201
    },
    {
        path: '/personal/esim/',
        name: 'Esim',
        name_ru: 'Е-сим',
        component: Esim,
        meta: {
            requiresAuth: true,
            title: 'Esim | PayWave',
            title_ru: 'Е-сим | PayWave',
        },
    },
    // {
    //     path: '/personal/bills/',
    //     name: 'Bills',
    //     name_ru: 'Мои счета',
    //     component: Bills,
    //     meta: {
    //         requiresAuth: true,
    //         // isBillGroup: true,
    //         title: 'My transfers | PayWave',
    //         title_ru: 'Мои счета | PayWave',
    //     },
    //     menu_type: ['leftAuth', 'mobAuth'],
    //     menu_level: 2,
    //     menu_parent: 'Lists of',
    //     sort: 202
    // },
    {
        path: '/personal/bill/:id',
        name: 'PersonalBill',
        component: PersonalBill,
        meta: {
            requiresAuth: true,
            isBillGroup: true,
            title: 'Bill | PayWave',
            title_ru: 'Счет | PayWave',
        },
    },
    {
        path: '/personal/partner/',
        name: 'Partner',
        name_ru: 'Партнерская программа',
        component: Partner,
        meta: {
            requiresAuth: true,
            title: 'Partner programm | PayWave',
            title_ru: 'Партнерская программа | PayWave',
        },
        sort: 202
    },
    {
        path: '/personal/partner/',
        name: 'Partner',
        name_ru: 'Партнерская программа',
        component: Partner,
        meta: {
            requiresAuth: true,
            title: 'Partner programm | PayWave',
            title_ru: 'Партнерская программа | PayWave',
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Products',
        sort: 301
    },
    {
        path: '/personal/vcards/',
        name: 'Vcards',
        name_ru: 'Виртуальные карты',
        component: Cards,
        meta: {
            requiresAuth: true,
            title: 'Vcards | PayWave',
            title_ru: 'Виртуальные карты | PayWave',
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Products',
        sort: 301
    },
    {
        path: '/merchant/',
        name: 'Merchant',
        name_ru: 'Обмен и выплаты',
        component: MerchantIndex,
        meta: {
            requiresAuth: true,
            title: 'Merchant | PayWave',
            title_ru: 'Торговец | PayWave',
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Products',
        sort: 301
    },
    // {
    //     path: '/personal/bills/',
    //     name: 'My bills',
    //     name_ru: 'Прием оплат',
    //     component: Bills,
    //     meta: {
    //         requiresAuth: true,
    //     },
    //     menu_type: ['leftAuth'],
    //     menu_level: 2,
    //     menu_parent: 'Products',
    //     sort: 301
    // },
    {   // скрыт
        path: '/personal/recipients/',
        name: 'Recipients',
        name_ru: 'Мои получатели',
        component: Recipients,
        meta: {
            requiresAuth: true,
            title: 'My Recipients | PayWave',
            title_ru: 'Мои получатели | PayWave',
        },
        // menu_level: 2,
        // menu_type: ['leftAuth'],
        // menu_parent: 'History',
        sort: 1
    },
    {   // скрыт
        path: '/personal/senders/',
        name: 'Senders',
        name_ru: 'Мои отправители',
        component: Senders,
        meta: {
            requiresAuth: true,
            title: 'My Senders | PayWave',
            title_ru: 'Мои отправители | PayWave',
        },
        // menu_level: 2,
        // menu_type: ['leftAuth'],
        // menu_parent: 'History',
        sort: 1
    },
    {   
        path: '/personal/sender/add/',
        name: 'SenderAdd',
        name_ru: 'Добавить отправителя',
        component: SenderAdd,
        meta: {
            requiresAuth: true,
            title: 'Add Sender | PayWave',
            title_ru: 'Добавить отправителя | PayWave',
        },
        sort: 1
    },
    {   
        path: '/personal/sender/edit/:id',
        name: 'SenderEdit',
        name_ru: 'Редактировать отправителя',
        component: SenderEdit,
        meta: {
            requiresAuth: true,
            title: 'Edit Sender | PayWave',
            title_ru: 'Редактировать отправителя | PayWave',
        },
        sort: 1
    },
    {
        path: '/personal/wallets/',
        name: 'Wallets',
        component: PersonalWallets,
        meta: {
            requiresAuth: true,
            title: 'Wallets | PayWave',
            title_ru: 'Кошелек общий | PayWave',
        },
    },
    {
        path: '/personal/transactions/',
        name: 'WalletsTransactions',
        component: WalletsTransactions,
        meta: {
            requiresAuth: true,
            title: 'Transactions | PayWave',
            title_ru: 'Транзакции | PayWave',
        },
    },
    {
        path: '/personal/wallet/:type',
        name: 'Wallet',
        component: PersonalWallet,
        meta: {
            requiresAuth: true,
            title: 'Wallet | PayWave',
            title_ru: 'Кошелек | PayWave',
        },
    },
    {
        path: '/personal/transactions/:type',
        name: 'PersonalTransactions',
        component: PersonalTransactions,
        meta: {
            requiresAuth: true,
            title: 'Transactions | PayWave',
            title_ru: 'Транзакции | PayWave',
        },
    },
    {
        path: '/personal/account/:id',
        name: 'Account',
        component: PersonalAccount,
        meta: {
            requiresAuth: true,
            title: 'Account | PayWave',
            title_ru: 'Счет | PayWave',
        },
    },
    {
        path: '/personal/vcards/',
        name: 'Cards',
        component: Cards,
        meta: {
            requiresAuth: true,
            title: 'Cards | PayWave',
            title_ru: 'Карты | PayWave',
        },
    },
    {
        path: '/personal/card/:id',
        name: 'VCard',
        component: VCard,
        meta: {
            requiresAuth: true,
            title: 'Card | PayWave',
            title_ru: 'Карта | PayWave',
        },
    },
    {
        path: '/personal/card/:id/transactions',
        name: 'PersonalVcardTrans',
        component: PersonalVcardTrans,
        meta: {
            requiresAuth: true,
            title: 'Card Transactions | PayWave',
            title_ru: 'Транзакции карты | PayWave',
        },
    },
    //mob personal
    {
        path: '/personal/transfer/create/',
        name: 'Create transfer',
        name_ru: "Создать перевод",
        component: TransferCreate,
        menu_type: ['mob', 'mobAuth'],
        sort: 1
    },
    {
        path: '/personal/bill/create/',
        name: 'Create bill',
        name_ru: "Создать счет",
        component: CreateBill,
        meta: {
            requiresAuth: true,
            isBillGroup: true,
        },
        menu_type: ['mobAuth'],
        meta: {
            isBillGroup: true,
        },
        sort: 1
    },
    {
        path: '/personal/transfers/',
        name: 'My transfers',
        name_ru: 'Мои переводы',
        component: Transfers,
        menu_type: ['mobAuth'],
        sort: 201
    },
    // {
    //     path: '/personal/bills/',
    //     name: 'My bills',
    //     name_ru: 'Мои счета',
    //     meta: {
    //         requiresAuth: true,
    //         // isBillGroup: true,
    //     },
    //     component: Bills,
    //     meta: {
    //         isBillGroup: true,
    //     },
    //     menu_type: ['mobAuth'],
    //     sort: 202
    // },
    {
        path: '/personal/partner/',
        name: 'Partner`s program',
        name_ru: 'Партнерская программа',
        component: Partner,
    },
    {
        path: '/personal/profile/',
        name: 'Profile',
        name_ru: 'Профиль',
        component: Profile,
        meta: {
            requiresAuth: true,
            title: 'Profile | PayWave',
            title_ru: 'Профиль | PayWave',
        },
        menu_type: ['mobAuth'],
        sort: 204
    },

    // MERCHANT
    {
        path: '/merchant/',
        name: 'Merchant',
        name_ru: 'Торг.',
        component: MerchantIndex,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/merchant/stat/',
        name: 'MerchantStat',
        name_ru: 'Моя статистика',
        component: MerchantStat,
        meta: {
            requiresAuth: true,
            requiresMerchant: true,
        },
        menu_type: ['mobAuth'],
        icon: 'pi-user',
        sort: 2
    },
    {
        path: '/merchant/transfers/',
        name: 'MerchantTransfers',
        name_ru: 'Переводы клиентов',
        component: MerchantTransfers,
        meta: {
            requiresAuth: true,
            requiresMerchant: true
        },
        menu_type: ['mobAuth'],
        icon: 'pi-list',
        sort: 1
    },
    {
        path: '/merchant/transfers/',
        name: 'MerchantTransfers',
        name_ru: 'Переводы клиентов',
        component: MerchantTransfers,
        meta: {
            requiresAuth: true,
            requiresMerchant: true
        },
        menu_type: ['leftAuth','mobAuth'],
        icon: 'pi-list',
        menu_level: 2,
        menu_parent: 'Merchant',
        sort: 11
    },
    {
        path: '/personal/wallets/',
        name: 'PersonalWallets',
        name_ru: 'Кошелек',
        component: PersonalWallets,
        meta: {
            requiresAuth: true,
        },
        menu_type: ['leftAuth','mobAuth'],
        icon: 'pi-wallet',
        menu_level: 1,
        // menu_parent: 'Merchant',
        sort: 11
    },
    {
        path: '/merchant/stat/',
        name: 'MyData',
        name_ru: 'Моя статистика',
        component: MerchantStat,
        meta: {
            requiresAuth: true,
            requiresMerchant: true
        },
        menu_type: ['leftAuth','mobAuth'],
        menu_level: 2,
        menu_parent: 'Merchant',
        sort: 12
    },
    {
        path: '/merchant/transfer/:id',
        name: 'MerchantTransferDetail',
        component: MerchantTransferDetail,
        meta: {
            requiresAuth: true,
            requiresMerchant: true
        },
    },
    {
        path: '/merchant/rates/',
        name: 'MrRates',
        name_ru: 'Курсы',
        component: MerchantRates,
        meta: {
            requiresAuth: true,
            requiresMerchant: true,
            title: 'Rates | Merchant | PayWave',
            title_ru: 'Курсы | Merchant | PayWave',
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Merchant',
    },
    {
        path: '/merchant/rates/',
        name: 'MrRates',
        name_ru: 'Курсы',
        component: MerchantRates,
        meta: {
            requiresAuth: true,
            requiresMerchant: true,
        },
        menu_type: ['mobAuth'],
        menu_level: 1,
    },

    // ADMIN
    {
        path: '/admin/',
        name: 'Admin',
        name_ru: 'Адм.',
        component: AdminIndex,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Admin | PayWave',
            title_ru: 'Админ | PayWave',
        },
        menu_type: ['leftAuth', 'mobAuth'],
    },
    {
        path: '/admin/balances/',
        name: 'AdminBalances',
        name_ru: 'Балансы',
        component: AdminBalances,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Balances | Admin | PayWave',
            title_ru: 'Балансы | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
        sort: 1,
    },
    {
        path: '/admin/stat/',
        name: 'AdminStat',
        name_ru: 'Статистика',
        component: AdminStat,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Statistics | Admin | PayWave',
            title_ru: 'Статистика | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
        sort: 1,
    },
    {
        path: '/admin/transfers/',
        name: 'AdmTransfers',
        name_ru: 'Переводы',
        component: AdmTransfers,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Transfers | Admin | PayWave',
            title_ru: 'Переводы |Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['mobAuth'],
        icon: 'pi-list',
        sort: 11
    },
    {
        path: '/admin/transfers/',
        name: 'AdmTransfers',
        name_ru: 'Переводы',
        component: AdmTransfers,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Transfers | Admin | PayWave',
            title_ru: 'Переводы | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
        sort: 11
    },
    {
        path: '/admin/transfer/:id',
        name: 'AdmTransferDetail',
        component: AdmTransferDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Transfer | Admin | PayWave',
            title_ru: 'Перевод | Админ | PayWave',
        },
    },
    {
        path: '/admin/users/',
        name: 'AdminUsers',
        name_ru: 'Пользователи',
        component: AdminUsers,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Users | Admin | PayWave',
            title_ru: 'Пользователи | Админ | PayWave',
            isNewTab: true
        },
        icon: 'pi-users',
        menu_type: ['mobAuth'],
        menu_parent: 'Admin',
        sort: 12
    },
    {
        path: '/admin/users/',
        name: 'AdminUsers',
        name_ru: 'Пользователи',
        component: AdminUsers,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Users | Admin | PayWave',
            title_ru: 'Пользователи | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth',],
        menu_level: 2,
        menu_parent: 'Admin',
        sort: 12
    },
    {
        path: '/admin/merchants/',
        name: 'AdminMerchants',
        name_ru: 'Мерчанты',
        component: AdminMerchants,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Merchants | Admin | PayWave',
            title_ru: 'Мерчанты | Админ | PayWave',
            isNewTab: true
        },
        icon: 'pi-sitemap',
        menu_type: ['mobAuth'],
        menu_parent: 'Admin',
        sort: 13
    },
    {
        path: '/admin/merchants/',
        name: 'AdminMerchants',
        name_ru: 'Мерчанты',
        component: AdminMerchants,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Merchants | Admin | PayWave',
            title_ru: 'Мерчанты | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth',],
        menu_level: 2,
        menu_parent: 'Admin',
        sort: 13
    },
    {
        path: '/admin/merchant/:id',
        name: 'AdmMerchantDetail',
        component: AdmMerchantDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Merchant | Admin | PayWave',
            title_ru: 'Мерчант | Админ | PayWave',
        },
    },
    {
        path: '/admin/user/:id',
        name: 'AdminUserDetail',
        component: AdminUserDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'User | Admin | PayWave',
            title_ru: 'Пользователь | Админ | PayWave',
        },
    },
    {
        path: '/admin/user_wallet/:id',
        name: 'AdminUserWalletDetail',
        component: AdminUserWalletDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'User Wallet | Admin | PayWave',
            title_ru: 'Кошелек пользователя | Админ | PayWave',
        },
    },
    {
        path: '/admin/partners/',
        name: 'AdminPartners',
        name_ru: 'Партнеры',
        component: AdmPartnerList,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Partners | Admin | PayWave',
            title_ru: 'Партнеры | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/partner/:id',
        name: 'AdminPartnerDetail',
        component: AdminPartnerDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Partner | Admin | PayWave',
            title_ru: 'Партнер | Админ | PayWave',
        },
    },
    {
        path: '/admin/files/',
        name: 'AdminFiles',
        name_ru: 'Файлы',
        component: AdminFiles,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Files | Admin | PayWave',
            title_ru: 'Файлы | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/operations/',
        name: 'AdminOperations',
        name_ru: 'Операции',
        component: AdminOperations,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Operations | Admin | PayWave',
            title_ru: 'Операции | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/vcards/',
        name: 'AdmVcards',
        name_ru: 'Виртуальные карты',
        component: AdmVcards,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Vcards | Admin | PayWave',
            title_ru: 'Виртуальные карты | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/vcard/:id',
        name: 'AdmVcardDetail',
        name_ru: 'Виртуальная карта',
        component: AdmVcardDetail,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Vcard | Admin | PayWave',
            title_ru: 'Виртуальная карта | Admin | PayWave',
        },
    },
    {
        path: '/admin/vcard/:id/transactions',
        name: 'AdmVcardTransactions',
        name_ru: 'Транзакции карты',
        component: AdminVcardTransactions,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Vcard Transactions | Admin | PayWave',
            title_ru: 'Транзакции карты | Admin | PayWave',
        },
    },
    {
        path: '/admin/wallets/',
        name: 'AdminWallets',
        name_ru: 'Кошельки',
        component: AdmWallets,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Wallets | Admin | PayWave',
            title_ru: 'Кошельки | Админ | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/wallet/:id',
        name: 'AdminWalletDetail',
        component: AdmWalletDetail,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Wallet | Admin | PayWave',
            title_ru: 'Кошелек | Админ | PayWave',
        },
    },
    {
        path: '/admin/accounts/',
        name: 'AdminAccounts',
        name_ru: 'Счета',
        component: AdmAccounts,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Accounts | Admin | PayWave',
            title_ru: 'Счета | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/account/:id',
        name: 'AdminAccDetail',
        component: AdmAccDetail,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Account | Admin | PayWave',
            title_ru: 'Счет | Admin | PayWave',
        },
    },
    {
        path: '/admin/transactions/',
        name: 'AdminTransactions',
        name_ru: 'Транзакции',
        component: AdmTrns,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'Transactions | Admin | PayWave',
            title_ru: 'Транзакции | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/rates/',
        name: 'AdminRates',
        name_ru: 'Курсы',
        component: AdmRates,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Rates | Admin | PayWave',
            title_ru: 'Курсы | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/banks/',
        name: 'AdminBanks',
        name_ru: 'Банки',
        component: AdmBanks,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Banks | Admin | PayWave',
            title_ru: 'Банки | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/pays/',
        name: 'AdminPays',
        name_ru: 'Плат.сис',
        component: AdminPays,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Pays | Admin | PayWave',
            title_ru: 'Плат.сис. | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/senders/',
        name: 'AdminSenders',
        name_ru: 'Отправители',
        component: AdminSenders,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Senders | Admin | PayWave',
            title_ru: 'Отправители | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/recipients/',
        name: 'AdminRecipients',
        name_ru: 'Получатели',
        component: AdminRecipients,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Recipients | Admin | PayWave',
            title_ru: 'Получатели | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/recipients/blacklist/',
        name: 'AdminRecipientsBlacklist',
        name_ru: 'Блэклист получателей',
        component: AdminRecipientsBlacklist,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Recipients Blacklist | Admin | PayWave',
            title_ru: 'Блэклист получателей | Admin | PayWave',
            isNewTab: true
        },
        menu_type: ['leftAuth'],
        menu_level: 2,
        menu_parent: 'Admin',
    },
    {
        path: '/admin/recipients/blacklist/add/',
        name: 'AdminRecipientsBlacklistAdd',
        name_ru: 'Добавить в блэклист получателей',
        component: AdminRecipientsBlacklist,
        meta: {
            requiresAuth: true,
            requiresManager: true,
            title: 'Add Recipient Blacklist | Admin | PayWave',
            title_ru: 'Добавить в блэклист получателей | Admin | PayWave',
        },
    },
    // SYSTEM
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
        name: 'Not found',
        meta: {
            title: 'Not found | PayWave',
            title_ru: 'Страница не найдена | PayWave',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    // base: process.env.BASE_URL,
    mode: 'history',
    routes
})

//меняем мета данные на лету
router.beforeEach((to, from, next) => {
    window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
    if(store.getters.StateLang=='ru'){
        document.title = (to.meta.title_ru) ? to.meta.title_ru : (to.meta.title) ? to.meta.title : 'PayWave'
    }else{
        document.title = (to.meta.title) ? to.meta.title : 'PayWave'
    }
    next()
});


router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.isBillGroup)) {
        if (isUserInGroup('bill', store.getters.StateGroups)) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresMerchant)) {
        if (store.getters.isAuthenticated && isUserInGroup('merchant', store.getters.StateGroups)) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresManager)) {
        if (store.getters.isAuthenticated && (isUserInGroup('manager', store.getters.StateGroups) || isUserInGroup('admin', store.getters.StateGroups))) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAdmin)) {
        if (store.getters.isAuthenticated && isUserInGroup('admin', store.getters.StateGroups)) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

export default router;